import React from 'react';
import { useNavigate } from 'react-router-dom';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import logoFull from '../../assets/images/logo-full.png';
import styles from './NotFound.module.css';

/**
 * Página de endereço inexistente. Logado, aparece dentro do app (com menu e
 * cabeçalho) e o botão leva ao Início; deslogado, ocupa a tela toda e o botão
 * leva à página inicial do site.
 */
const NotFound = ({ homePath = '/', standalone = false }) => {
  const navigate = useNavigate();

  return (
    <div className={standalone ? styles.page : styles.inApp}>
      <div className={styles.card}>
        {standalone && <img src={logoFull} alt="Gabriela" className={styles.logo} />}
        <span className={styles.icon}>
          <SearchOffOutlinedIcon />
        </span>
        <h1 className={styles.title}>Não encontramos esta página</h1>
        <p className={styles.text}>O endereço pode ter mudado ou estar digitado errado.</p>
        <button type="button" className={styles.button} onClick={() => navigate(homePath, { replace: true })}>
          Ir para o Início
        </button>
      </div>
    </div>
  );
};

export default NotFound;
